import { Button } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useTenantTranslation } from "hooks/formatters";
import { useCallback } from "react";
import { downloadCsv, CsvColumnDef } from "src/utils/csv";

export const DownloadStatsCsvButton = <T,>({
  rows,
  columns,
  filename,
}: {
  rows: T[];
  columns: CsvColumnDef<T>[];
  filename: () => string;
}) => {
  const { t } = useTenantTranslation();

  const handleDownload = useCallback(() => {
    downloadCsv({ rows, columns, filename: filename() });
  }, [rows, columns, filename]);

  return (
    <Button
      variant="text"
      color="primary"
      onClick={handleDownload}
      startIcon={<CloudDownloadIcon />}
      sx={{ whiteSpace: "nowrap" }}
      disabled={rows.length === 0}
    >
      {t("downloadCsv")}
    </Button>
  );
};
